import { render, staticRenderFns } from "./ProjectReportSummary.vue?vue&type=template&id=f04738ee"
import script from "./ProjectReportSummary.vue?vue&type=script&lang=js"
export * from "./ProjectReportSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports